import * as XLSX from 'xlsx';

const SKIP_LABELS = new Set(['Счет', 'Контрагенты', 'Итого']);
const ACCOUNT_CODE_RE = /^\d+(\.\d+)*$/;
const PERSON_NAME_RE = /^[А-ЯЁ][а-яё]+(?:\s[А-ЯЁ][а-яё]+){1,2}$/;

function toNumber(v) {
    if (v === undefined || v === null || v === '') return null;
    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
    return Number.isNaN(n) ? null : n;
}

function round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function parseAccountingFile(arrayBuffer, dateStart, dateEnd) {
    const wb = XLSX.read(arrayBuffer, { type: 'array' });
    const sheet = wb.Sheets[wb.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true, defval: '' });

    const result = [];
    let current = null;

    const pushCurrent = () => {
        if (!current) return;
        current.turnover = round2(current._turnover);
        current.special_turnover = round2(current._specialTurnover);
        current.end_balance = round2(current._endBalance);
        current.special_end_balance = round2(current._specialEndBalance);
        delete current._turnover;
        delete current._specialTurnover;
        delete current._endBalance;
        delete current._specialEndBalance;
        result.push(current);
    };

    for (const row of rows) {
        const label = row[0] ? String(row[0]).trim() : '';
        if (!label && row.slice(1).every((c) => c === '')) continue; // пустая строка

        if (SKIP_LABELS.has(label) || ACCOUNT_CODE_RE.test(label)) continue; // шапка / код счёта / итого

        if (PERSON_NAME_RE.test(label)) {
            // строка ФИО — новый человек
            pushCurrent();

            current = {
                fio: label,
                _turnover: 0,
                _specialTurnover: 0,
                _endBalance: 0,
                _specialEndBalance: 0,
                operations: [],
                special_operations: [],
            };
            continue;
        }

        // строка-статья: относим к текущему человеку
        if (current) {
            const debit = toNumber(row[3]);
            const credit = toNumber(row[4]);
            const endDebit = toNumber(row[5]);
            const endCredit = toNumber(row[6]);

            // если вообще никаких данных по строке нет — пропускаем полностью
            if (debit === null && credit === null && endDebit === null && endCredit === null) continue;

            const ed = endDebit || 0;
            const ec = endCredit || 0;
            const lowerLabel = label.toLowerCase();
            const isSpecial = lowerLabel.includes('целевые');

            // сальдо на конец периода учитываем всегда, даже если движения не было
            if (isSpecial) {
                current._specialEndBalance += ec - ed;
            } else {
                current._endBalance += ec - ed;
            }

            // в operations/special_operations и в turnover попадают только строки с движением
            if (debit === null && credit === null) continue;

            const d = debit || 0;
            const c = credit || 0;

            const op = {
                description: `${label} (за период ${dateStart}-${dateEnd})` || 'Операция',
                is_initial: true,
                debit: d,
                credit: c,
            };

            if (isSpecial) {
                current._specialTurnover += c - d;
                current.special_operations.push(op);
            } else {
                current._turnover += c - d;
                current.operations.push(op);
            }
        }
    }
    pushCurrent();

    return result;
}